export default {
  api: {
    baseUrl: 'http://10.212.113.124:7000',
    chatUrl: 'http://10.212.113.124:7002',
    // baseUrl: 'http://localhost:7000',
  },
};
